module.exports = __webpack_public_path__ + "static/media/icr.981a19e7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/icr.mp3
// module id = 13734
// module chunks = 0